export default __webpack_public_path__ + "static/media/motupatlo1.50e70048.jpg";